import type { ClientAppointment } from '@cartwheel/api/v1'
import { Badge, DataTable } from '@cartwheel/components'
import { getAppointmentDisplayStatus, getAppointmentStatusColor } from '../lib/appointment-utils'
import { formatDate, formatTime } from '../lib/date-utils'

export type Appointment = ClientAppointment

export interface AppointmentRowProps {
  appointment: Appointment
  clientTimeZone: string
}

export function AppointmentRow({ appointment, clientTimeZone }: AppointmentRowProps) {
  const displayStatus = getAppointmentDisplayStatus(appointment.status, appointment.soft_deleted)
  const displayTime = formatTime(appointment.start_time ?? null, clientTimeZone)

  return (
    <DataTable.Row>
      <DataTable.Cell label="Date & Time" className="whitespace-nowrap text-sm text-charcoal">
        {formatDate(appointment.date)}
        {displayTime && <> at {displayTime}</>}
      </DataTable.Cell>
      <DataTable.Cell label="Journey" className="text-sm text-charcoal">
        {appointment.journey_name || '—'}
      </DataTable.Cell>
      <DataTable.Cell label="Status" className="whitespace-nowrap">
        <Badge
          label={displayStatus}
          color={getAppointmentStatusColor(appointment.status, appointment.soft_deleted)}
        />
      </DataTable.Cell>
      <DataTable.Cell label="Appointment Type" className="text-sm text-charcoal">
        {appointment.appointment_type_name || '—'}
      </DataTable.Cell>
      <DataTable.Cell label="Clinician" className="whitespace-nowrap text-sm text-charcoal">
        {appointment.clinician_name || '—'}
      </DataTable.Cell>
    </DataTable.Row>
  )
}
